import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import App from './App';
import QRExamples from './examples/QRExamples';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
	<BrowserRouter>
	  <Routes>	   
	   <Route path="/qr/create/examples/" element={<QRExamples />} />
	   <Route path="/qr/create/:formName/" element={<App />} />	   
	  </Routes>		
	</BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
